import React from "react";
import { cn } from "../../lib/utils";

const SectionHeader = ({
  text,
  headingColor = "text-[var(--color-neutral-10)]",
  className,
}) => {
  return (
    <div className={`flex justify-between items-center ${headingColor}`}>
      <h4 className={cn("font-semibold", className)}>{text}</h4>
    </div>
  );
};
export { SectionHeader };
